import { TempoFilterConfig } from 'constants/filters';

export const getSliderPositionFromValue = (
    value: number,
    maxSliderPosX: number,
): number => {
    const ratio =
        (value - TempoFilterConfig.MinBpm) /
        (TempoFilterConfig.MaxBpm - TempoFilterConfig.MinBpm);
    const newPosXFromBpmPercent = maxSliderPosX * ratio;
    const roundedResult = newPosXFromBpmPercent.toFixed(2);

    return parseInt(roundedResult, 10);
};

export const getValueFromSliderPosition = (
    x: number,
    maxSliderPosX: number,
): number => {
    const ratio = x / (maxSliderPosX - TempoFilterConfig.ButtonRadius / 2);
    let result =
        (TempoFilterConfig.MaxBpm - TempoFilterConfig.MinBpm) * ratio +
        TempoFilterConfig.MinBpm;

    if (result > TempoFilterConfig.MaxBpm) {
        result = TempoFilterConfig.MaxBpm;
    } else if (result < TempoFilterConfig.MinBpm) {
        result = TempoFilterConfig.MinBpm;
    }

    const roundedResult = result.toFixed(2);

    return Math.round(parseInt(roundedResult, 10));
};
